module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.payments), function(payment) {
    return _c('payment-single-row', {
      key: payment.id,
      staticClass: "mb-1",
      attrs: {
        "isUnsavedRefund": payment.id < 0,
        "payment": payment,
        "refunds": _vm.refunds,
        "reservation": _vm.reservation
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1dd6a08"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabPayments/paymentRows.vue
// module id = 1759
// module chunks = 0